export default __webpack_public_path__ + "ec22b942484693967c17140bb96ef5ce.png";